import { render } from "./app-receipt.vue?vue&type=template&id=495262b9"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-receipt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "495262b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('495262b9', __exports__)) {
    console.log('reload')
    api.reload('495262b9', __exports__)
  }
  
  module.hot.accept("./app-receipt.vue?vue&type=template&id=495262b9", () => {
    console.log('re-render')
    api.rerender('495262b9', render)
  })

}


export default __exports__